// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3cwVZ","header":"MergedInvoice_header___Kc62"};